import '../App.css';
//IMPORTS DE LA BASE
import ProductsBase from "../components/products/ProductBasePage";
import background from '../assets/img/ofimatica3.png'
import backgroundBusiness from '../assets/img/ecommerce-Medium-780x430-1.jpg'
import logo from "../assets/img/advise_consultore_logo-removebg-preview.png"
import monitor from "../assets/img/cm/monitorcm.png"
import "../assets/styles/paneles.css"
import { ConvenioMarcoEnum } from '../enums/ConvenioMarcoEnum';
//IMPORTS DE LAS CARACTERISTICAS
import ProductCharacteristics from "../components/products/ProductCharacteristics";
import char0 from "../assets/img/cm/char0.png"
import char1 from "../assets/img/cm/char1.png"
import char2 from "../assets/img/cm/char2.png"
import char3 from "../assets/img/cm/char3.png"
import char4 from "../assets/img/cm/char4.png"
import char5 from "../assets/img/cm/char5.png"
//IMPORTS DEL FOOTER
import ProductContactUs from '../components/products/ProductConctactUs';

import Footer from "../components/Footer";
import { ServiceEnums } from '../enums/ServicesEnum';

export default function ConvenioMarcoAdvise(props){

    const productBaseProps = {
        isLargeScreen: props.isLargeScreen,
        background: background,
        backgroundBusiness: backgroundBusiness,
        logo: logo,
        mainTitle: ConvenioMarcoEnum.PRODUCT_TITLE,
        mainDescription: ConvenioMarcoEnum.PRODUCT_DESCRIPTION,
        screenshot: monitor,
        referenceComponent: "service-card-4"
    }

    const productCharacterisitcsProps = {
        isLargeScreen: props.isLargeScreen,
        data: [
            {
                title: ConvenioMarcoEnum.OUR_SOLUTION_1_TITLE,
                description: ConvenioMarcoEnum.OUR_SOLUTION_1_DESC,
                imgLink: [char0]
            },
            {
                title: ConvenioMarcoEnum.OUR_SOLUTION_2_TITLE,
                description: ConvenioMarcoEnum.OUR_SOLUTION_2_DESC,
                imgLink: [char1]
            },
            {
                title: ConvenioMarcoEnum.OUR_SOLUTION_3_TITLE,
                description: ConvenioMarcoEnum.OUR_SOLUTION_3_DESC,
                imgLink: [char2]
            },
            {
                title: ConvenioMarcoEnum.OUR_SOLUTION_4_TITLE,
                description: ConvenioMarcoEnum.OUR_SOLUTION_4_DESC,
                imgLink: [char3]
            },
            {
                title: ConvenioMarcoEnum.OUR_SOLUTION_5_TITLE,
                description: ConvenioMarcoEnum.OUR_SOLUTION_5_DESC,
                imgLink: [char4]
            },
            {
                title: ConvenioMarcoEnum.OUR_SOLUTION_6_TITLE,
                description: ConvenioMarcoEnum.OUR_SOLUTION_6_DESC,
                imgLink: [char5]
            }
        ]
    }

    const productsContactProps = {
        isLargeScreen: props.isLargeScreen,
        nameProducto: "Marco Analyzer",
        contactTitle: ConvenioMarcoEnum.CONTACT_TITLE,
        contactDesc: ConvenioMarcoEnum.CONTACT_DESCRIPTION
    }

    return(
        <>
            <ProductsBase {...productBaseProps}/>
            <div className='information-section'>
                <ProductCharacteristics {...productCharacterisitcsProps}/>
                <ProductContactUs {...productsContactProps}/>    
                <Footer isService={true} origin={ServiceEnums.MSA}/>     
            </div>     
        </>
    )
}